import { messaging, getToken } from "./firebase-messaging";
import axios from "./axios";

const VAPID_KEY =
  process.env.REACT_APP_PUBLIC_VAPID_KEY ||
  "BBGKXZTNZYudlq-1Byuovg-i0ikbgmZBd12ZeIYMsHA8I0lbIfOo7UrVjUInsgkdnKdBwXzcjie8ke1-Rp8KICY";

// Enregistre ou rafraîchit le token FCM pour un utilisateur connecté.
// Silencieux si les notifications sont refusées ou non supportées.
export async function registerPushToken(userId) {
  if (!userId || !messaging) return;
  try {
    if (typeof Notification === "undefined") return;
    if (Notification.permission !== "granted") return;

    const registration = await navigator.serviceWorker.ready;
    const fcmToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    if (!fcmToken) return;

    // Refresh : n'envoie au backend que si le token a changé
    const storedToken = localStorage.getItem("fcm_token");
    if (fcmToken === storedToken) return;

    localStorage.setItem("fcm_token", fcmToken);

    await axios.post("/push/save-fcm-token", { userId, fcmToken });
    console.log("✅ [FCM] Token enregistré / rafraîchi");
  } catch (err) {
    console.warn("⚠️ [FCM] registerPushToken silencieux :", err.message);
  }
}
